import * as React from "react";
import { DEFAULT_API_HOSTNAME } from "./api/config";
const WidgetsContext = React.createContext(undefined);
WidgetsContext.displayName = "WidgetsContext";
export { WidgetsContext };
export function useWorkOsApiUrl() {
    const context = React.useContext(WidgetsContext);
    return context?.apiBaseUrl || `https://${DEFAULT_API_HOSTNAME}`;
}
export function useElement(key) {
    const context = React.useContext(WidgetsContext);
    if (!context) {
        throw new Error("useElement must be used within a WidgetsContext provider");
    }
    return context.elements[key] || {};
}
//# sourceMappingURL=widgets-context.js.map